import _ from 'lodash'

const shallowCompareObject = (o1, o2) => {
  return Array.isArray(o1) && Array.isArray(o2) ?
    o1.length === o2.length :
    _.isEqual(Object.keys(o1).sort(), Object.keys(o2).sort())
}
export default shallowCompareObject